<template>
<div class="chapter">
<div class="inner_page">
<div class="toc">
<p class="toc"><img alt="" src="OEBPS/images/line.jpg"/></p>
<h1 class="toc">C<span class="small1">ONTENTS</span></h1>
<p class="toc"><a href="#/OEBPS/ack.htm">Acknowledgments</a><br/><br/></p>
<p class="toc"><a href="#/OEBPS/intro.htm">Introduction: Reversed Colonialism</a><br/><br/></p>
<p class="toc"><a href="#/OEBPS/ch01.htm"><span class="small">ONE</span> Conquest</a><br/><br/></p>
<p class="toc"><a href="#/OEBPS/ch02.htm"><span class="small">TWO</span> New Order</a><br/><br/></p>
<p class="toc"><a href="#/OEBPS/ch03.htm"><span class="small">THREE</span> The Embrace</a><br/><br/></p>
<p class="toc"><a href="#/OEBPS/ch04.htm"><span class="small">FOUR</span> The Empire of the Plains</a><br/><br/></p>
<p class="toc"><a href="#/OEBPS/ch05.htm"><span class="small">FIVE</span> Greater Comanchería</a><br/><br/></p>
<p class="toc"><a href="#/OEBPS/ch06.htm"><span class="small">SIX</span> Children of the Sun</a><br/><br/></p>
<p class="toc"><a href="#/OEBPS/ch07.htm"><span class="small">SEVEN</span> Hunger</a><br/><br/></p>
<p class="toc"><a href="#/OEBPS/ch08.htm"><span class="small">EIGHT</span> Collapse</a><br/><br/></p>
<p class="toc"><a href="#/OEBPS/conclusion.htm">Conclusion: The Shape of Power</a><br/><br/></p>
<p class="toc"><a href="#/OEBPS/abb.htm">List of Abbreviations</a><br/><br/></p>
<p class="toc"><a href="#/OEBPS/note1.htm">Notes</a><br/><br/></p>
<p class="toc"><a href="#/OEBPS/bib.htm">Bibliography</a><br/><br/></p>
<p class="toc"><a href="#/OEBPS/index.htm">Index</a><br/><br/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?3c035dfe